import { render, staticRenderFns } from "./NvrPlayer.vue?vue&type=template&id=ced7a862&scoped=true"
import script from "./NvrPlayer.vue?vue&type=script&lang=js"
export * from "./NvrPlayer.vue?vue&type=script&lang=js"
import style0 from "./NvrPlayer.vue?vue&type=style&index=0&id=ced7a862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced7a862",
  null
  
)

export default component.exports